import ClustersAPI from 'dashboard/api/clusters';

export const state = {
  records: [],
  meta: { count: 0, currentPage: 1, totalPages: 1 },
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getClusters: $state => $state.records,
  getCluster: $state => id => $state.records.find(r => r.id === Number(id)),
  getMeta: $state => $state.meta,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  async fetch({ commit }, params = {}) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ClustersAPI.get(params);
      commit('setClusters', data.payload);
      commit('setMeta', data.meta);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async show({ commit }, id) {
    commit('setUIFlag', { isFetchingItem: true });
    try {
      const { data } = await ClustersAPI.show(id);
      commit('upsertCluster', data);
      return data;
    } finally {
      commit('setUIFlag', { isFetchingItem: false });
    }
  },

  async create({ commit }, payload) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await ClustersAPI.create(payload);
      commit('upsertCluster', data);
      return data;
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...payload }) {
    commit('setUIFlag', { isUpdating: true });
    try {
      const { data } = await ClustersAPI.update(id, payload);
      commit('upsertCluster', data);
      return data;
    } finally {
      commit('setUIFlag', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('setUIFlag', { isDeleting: true });
    try {
      await ClustersAPI.delete(id);
      commit('removeCluster', id);
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  setClusters($state, records) {
    $state.records = records || [];
  },
  setMeta($state, meta = {}) {
    $state.meta = {
      count: meta.count || 0,
      currentPage: meta.current_page || 1,
      totalPages: meta.total_pages || 1,
    };
  },
  upsertCluster($state, record) {
    if (!record || !record.id) return;
    const i = $state.records.findIndex(r => r.id === record.id);
    if (i > -1) {
      const next = [...$state.records];
      next[i] = record;
      $state.records = next;
    } else {
      $state.records = [record, ...$state.records];
    }
  },
  removeCluster($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
